export const RESOURCE_COLOR_NAMES = [
  'documents',
  'communications',
  'rendezVous',
  'rendez-vous',
  'incident',
  'rappel',
  'autre',
  'providers',
  'task',
  'pending_item',
] as const;

export type ResourceColorName = (typeof RESOURCE_COLOR_NAMES)[number];

export type ResourceColorPalette = {
  main: string;
  light: string;
  dark: string;
  contrastText: string;
};

export type ResourceColors = Record<ResourceColorName, ResourceColorPalette>;

export const resourcesColors: ResourceColors = {
  documents: {
    main: '#7b1fa2',
    light: '#f3e5f5',
    dark: '#4a148c',
    contrastText: '#ffffff',
  },
  communications: {
    main: '#a66000',
    light: '#fff8e1',
    dark: '#7a4400',
    contrastText: '#ffffff',
  },
  rendezVous: {
    main: '#00796b',
    light: '#e0f2f1',
    dark: '#004d40',
    contrastText: '#ffffff',
  },
  'rendez-vous': {
    main: '#00796b',
    light: '#e0f2f1',
    dark: '#004d40',
    contrastText: '#ffffff',
  },
  incident: {
    main: '#c62828',
    light: '#ffebee',
    dark: '#b71c1c',
    contrastText: '#ffffff',
  },
  rappel: {
    main: '#b54500',
    light: '#fff3e0',
    dark: '#8c3300',
    contrastText: '#ffffff',
  },
  autre: {
    main: '#616161',
    light: '#f5f5f5',
    dark: '#212121',
    contrastText: '#ffffff',
  },
  providers: {
    main: '#0288d1',
    light: '#e1f5fe',
    dark: '#01579b',
    contrastText: '#ffffff',
  },
  task: {
    main: '#1619a1',
    light: '#e8eaf6',
    dark: '#0f1170',
    contrastText: '#ffffff',
  },
  pending_item: {
    main: '#0288d1',
    light: '#e1f5fe',
    dark: '#01579b',
    contrastText: '#ffffff',
  },
};
